import React from 'react';

const GrainFilter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute' }}>
    <defs>
      <filter id="grain" width="100%" height="100%" x="0%" y="0%">
        <feTurbulence baseFrequency="0.6" numOctaves="3" result="NOISE" />
        <feDisplacementMap in="SourceGraphic" in2="NOISE" scale="2.5" />
      </filter>
    </defs>
  </svg>
);

export default GrainFilter;
